'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSign$002dStats from "./presto.types$-Dashboard-Sign-Stats.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardSignStats$() {
}
export { $c_Lpresto_types$DashboardSignStats$ as $c_Lpresto_types$DashboardSignStats$ };
$p = $c_Lpresto_types$DashboardSignStats$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardSignStats$;
/** @constructor */
function $h_Lpresto_types$DashboardSignStats$() {
}
export { $h_Lpresto_types$DashboardSignStats$ as $h_Lpresto_types$DashboardSignStats$ };
$h_Lpresto_types$DashboardSignStats$.prototype = $p;
$p.l = (function() {
  return "DashboardSignStats";
});
$p.cGw = (function(x$0) {
  return new $j_presto$002etypes$0024$002dDashboard$002dSign$002dStats.$c_Lpresto_types$DashboardSignStats((x$0.j(0) | 0), (x$0.j(1) | 0));
});
var $d_Lpresto_types$DashboardSignStats$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardSignStats$, "presto.types$DashboardSignStats$", ({
  Zl: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$DashboardSignStats$ as $d_Lpresto_types$DashboardSignStats$ };
var $n_Lpresto_types$DashboardSignStats$;
function $m_Lpresto_types$DashboardSignStats$() {
  if ((!$n_Lpresto_types$DashboardSignStats$)) {
    $n_Lpresto_types$DashboardSignStats$ = new $c_Lpresto_types$DashboardSignStats$();
  }
  return $n_Lpresto_types$DashboardSignStats$;
}
export { $m_Lpresto_types$DashboardSignStats$ as $m_Lpresto_types$DashboardSignStats$ };
//# sourceMappingURL=presto.types$-Dashboard-Sign-Stats$.js.map
